"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLineForProductData = void 0;
const dashboard_1 = require("./dashboard");
class SalesOrderLineForProductData {
}
exports.SalesOrderLineForProductData = SalesOrderLineForProductData;
//# sourceMappingURL=sales-order-lines-for-product-data.response.js.map